import { ErrorSwalHtml } from "../../../../../../Utils/Utils/DecisionSwal";

export const MostrarMensajeBultoSkimSinAnalisis = () => {
    const html = `
        <div class="text-start text-sm">
            <p class="mb-0">
                Este bulto ya fue utilizado y aún no tiene su análisis de DRC validado.
            </p>

            <p class="mb-0 mt-2">
                Si se descarta ahora, el laboratorista ya no podrá encontrarlo para
                completar el análisis. Espere a que el análisis de DRC sea validado
                antes de descartarlo.
            </p>
        </div>`;
    ErrorSwalHtml(html, "Entendido");
};
